// @flow

import React from 'react';

type Props = {
  tabIndex: Number,
  children: Element,
};

export default function Tab({ children }: Props) {
  return <>{children}</>;
}
